export default __webpack_public_path__ + "static/media/eyes.db27b073.svg";